import React from "react";
import { BannerWidget } from "./Banner";
import { PopUpWidget } from "./PopUp";
import { PageRedirect } from "./Page";

import ContentUnavailable from "../ContentUnavailable";

const IIRISTargetType: React.FC<any> = (props) => {
  const target_config = props.config;
  const apiDomain = import.meta.env.VITE_API_BASE_URL;

  const WidgetLayout = () => {
    let layoutType: string | React.JSX.Element = "";
    switch (target_config.widgetType) {
      case "banner":
        layoutType = <BannerWidget banner_target_config={target_config} apiDomain={apiDomain} />
        break;
      case "popupv2":
        layoutType = <PopUpWidget popup_target_config={target_config} apiDomain={apiDomain} />
        break;
      case "page":
        layoutType = <PageRedirect page_target_config={target_config} apiDomain={apiDomain} />;
        break;
      default:
        <ContentUnavailable />;
        break;
    }
    return layoutType;
  };
  
  return <WidgetLayout />;
};

export { IIRISTargetType };
